var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { TemplateTag } from '@debbie/common/dist/templates';
import * as templatesAPI from '@debbie/cortex/dist/api/templates';
import { Button, Modal, Select } from '../..';
const VersionsModal = (props) => {
    const lang = useSelector((s) => s.lang);
    const [selectedTag, setSelectedTag] = useState(undefined);
    const addTag = (templateId, tag) => __awaiter(void 0, void 0, void 0, function* () {
        yield templatesAPI.patch(templateId, { tag: { tag: tag } });
    });
    return (React.createElement(Modal, { header: lang.templates.addTag, onToggle: props.toggleTagModal },
        React.createElement(Select, { value: selectedTag, onChange: (e) => setSelectedTag(e.target.value) },
            React.createElement("option", { value: undefined },
                "- ",
                lang.templates.selectTag,
                " -"),
            Object.values(TemplateTag).map((tag) => (React.createElement("option", { key: tag, value: tag }, lang.templateTags[tag])))),
        React.createElement(Button, { onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                if (selectedTag) {
                    yield addTag(props.templateId, selectedTag);
                }
                props.toggleTagModal();
                props.loadTemplate();
            }), disabled: !selectedTag }, lang.templates.addTag)));
};
export default VersionsModal;
//# sourceMappingURL=AddTagModal.js.map